import { render, staticRenderFns } from "./AutoCheckTabs.vue?vue&type=template&id=5b7ddc9c&"
import script from "./AutoCheckTabs.vue?vue&type=script&lang=js&"
export * from "./AutoCheckTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports